import { render, staticRenderFns } from "./UserSpace.vue?vue&type=template&id=7839fb4a&scoped=true"
import script from "./UserSpace.vue?vue&type=script&lang=js"
export * from "./UserSpace.vue?vue&type=script&lang=js"
import style0 from "./UserSpace.vue?vue&type=style&index=0&id=7839fb4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7839fb4a",
  null
  
)

export default component.exports